import React from 'react';

export const InformationSource = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="304"
    height="304"
    viewBox="0 0 304 304"
    fill="#000"
    {...props}
  >
    <title>Information source</title>
    <path d="M151.547 0a151.547 151.547 0 100 303.093 151.547 151.547 0 000-303.093zm0 265.21v-.004a113.65 113.65 0 01-80.367-33.289 113.661 113.661 0 010-160.738 113.661 113.661 0 01160.738 0 113.661 113.661 0 010 160.738 113.661 113.661 0 01-80.371 33.289v.004z" />
    <path d="M132.607 142.07h37.887v85.246h-37.887V142.07zM170.497 94.71c0 10.461-8.481 18.941-18.945 18.941-10.461 0-18.941-8.48-18.941-18.941 0-10.46 8.48-18.945 18.941-18.945 10.465 0 18.945 8.484 18.945 18.945z" />
  </svg>
);

export const SearchIcon = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

export const UserIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 360 360"
    {...props}
  >
    <defs>
      <path
        id="a"
        d="M342.4 309.9c0-62.7-51-113.7-113.7-113.7h-97.4c-62.7 0-113.7 51-113.7 113.7v32.5h324.8v-32.5zm-292.3 0c0-44.8 36.4-81.2 81.2-81.2h97.4c44.8 0 81.2 36.4 81.2 81.2H50.1z"
      />
    </defs>
    <clipPath id="b">
      <use xlinkHref="#a" overflow="visible" />
    </clipPath>
    <path
      clipPath="url(#b)"
      fill="currentColor"
      d="M-83.9 94.8h527.7v349.1H-83.9z"
    />
    <defs>
      <path
        id="c"
        d="M261.2 98.8c0-44.8-36.4-81.2-81.2-81.2S98.8 54 98.8 98.8 135.2 180 180 180s81.2-36.4 81.2-81.2m-129.9 0c0-26.9 21.9-48.7 48.7-48.7s48.7 21.9 48.7 48.7-21.9 48.7-48.7 48.7-48.7-21.8-48.7-48.7"
      />
    </defs>
    <clipPath id="d">
      <use xlinkHref="#c" overflow="visible" />
    </clipPath>
    <path
      clipPath="url(#d)"
      fill="currentColor"
      d="M-2.7-83.9h365.4v365.4H-2.7z"
    />
  </svg>
);

export const ClientIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360" {...props}>
    <path
      fill="currentColor"
      d="M328.1 68.4h-14.8V53.6h-29.6v14.8H247V24H113.8v44.4H76.3V53.6H46.7v14.8H31.9C15.6 68.4 2.3 81.7 2.3 98v207.3c0 16.3 13.3 29.6 29.6 29.6h296.2c16.3 0 29.6-13.3 29.6-29.6V98c0-16.3-13.3-29.6-29.6-29.6zM143.4 53.6h74v14.8h-74V53.6zm184.7 251.7H31.9v.1V98h296.2v207.3z"
    />
  </svg>
);

export function DownloadIcon({ fill = '#000', ...rest }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...rest}>
      <path
        fill={fill}
        d="M12 3.782a1.2 1.2 0 00-1.2 1.2v5.87L8.98 9.147a1.2 1.2 0 10-1.64 1.75l3.84 3.6c.02.022.047.036.071.055.03.027.063.051.096.075.034.02.07.04.106.057.031.017.062.036.096.048.042.016.085.03.13.041.03 0 .06.02.09.026.153.031.31.031.461 0 .032 0 .06-.016.092-.026a1.18 1.18 0 00.13-.04c.033-.015.064-.032.095-.049.036-.017.072-.036.106-.057a1.23 1.23 0 00.096-.075c.024-.019.05-.033.072-.055l3.84-3.6a1.2 1.2 0 10-1.642-1.75L13.2 10.853v-5.87a1.2 1.2 0 00-1.2-1.2z"
      />
      <path
        fill={fill}
        d="M18.72 14.458a1.2 1.2 0 00-1.2 1.2v1.92a.24.24 0 01-.24.24H6.72a.24.24 0 01-.24-.24v-1.92a1.2 1.2 0 10-2.4 0v1.92a2.64 2.64 0 002.64 2.64h10.56a2.64 2.64 0 002.64-2.64v-1.92a1.2 1.2 0 00-1.2-1.2z"
      />
    </svg>
  );
}

export const ChevronDown = props => {
  const randomID = Math.random();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 23 18"
      enableBackground="new 0 0 23 18"
      xmlSpace="preserve"
      {...props}
    >
      <g>
        <clipPath id={randomID}>
          <path d="M21.6,1.6c-0.2-0.2-0.3-0.3-0.5-0.3c-0.2,0-0.4,0.1-0.5,0.3L11.5,12L2.4,1.6C2.3,1.5,2.1,1.4,1.9,1.4    c-0.2,0-0.4,0.1-0.5,0.3L0.2,3C0.1,3.1,0,3.3,0,3.6C0,3.8,0.1,4,0.2,4.2L11,16.4c0.2,0.2,0.3,0.3,0.5,0.3s0.4-0.1,0.5-0.3    L22.8,4.2C22.9,4,23,3.8,23,3.6c0-0.2-0.1-0.4-0.2-0.6L21.6,1.6z" />
        </clipPath>
        <rect
          x="-9.7"
          y="-8.3"
          clipPath={`url(#${randomID})`}
          fill="currentColor"
          width="42.3"
          height="34.6"
        />
      </g>
    </svg>
  );
};

export const DraggableIcon = props => {
  return (
    <svg {...props} width="15" height="13" xmlns="http://www.w3.org/2000/svg">
      <g fill="#aaa" fillRule="evenodd">
        <path d="M0 0h15v3H0zM0 5h15v3H0zM0 10h15v3H0z" />
      </g>
    </svg>
  );
};

export const PlusIcon = props => {
  return (
    <svg {...props} width="14" height="14" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.475 12.754V8.237H.928a.596.596 0 0 1-.576-.576V5.963c0-.303.273-.576.576-.576h4.547V.81c0-.303.273-.546.576-.546H7.75c.303 0 .576.243.576.546v4.577h4.577c.303 0 .546.273.546.576v1.698c0 .303-.243.576-.546.576H8.325v4.517c0 .303-.273.545-.576.545H6.05c-.303 0-.576-.242-.576-.545z"
        fill="#FFF"
        fillRule="evenodd"
      />
    </svg>
  );
};
export const MinusIcon = props => {
  return (
    <svg {...props} width="14" height="9" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M.928 3.237a.596.596 0 0 1-.576-.576V.963C.352.66.625.387.928.387h11.974c.303 0 .546.273.546.576v1.698c0 .303-.243.576-.546.576H.928z"
        fill="#FFF"
        fillRule="evenodd"
      />
    </svg>
  );
};
export const AlertIcon = props => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 156">
      <defs />
      <g id="Layer_2" data-name="Layer 2">
        <g id="artwork">
          <circle cx="78" cy="78" r="78" fill="#f0f0f0" />
          <path
            className="cls-2"
            d="M83.14 45.48v-5.85A5.13 5.13 0 0 0 78 34.5a5.13 5.13 0 0 0-5.14 5.13v5.85"
          />
          <path
            className="cls-2"
            d="M78 43.94a28.43 28.43 0 0 0-28.43 28.43v24.9a7.91 7.91 0 0 0-7.9 7.91v2H78M78 43.94a28.43 28.43 0 0 1 28.43 28.43v24.9a7.91 7.91 0 0 1 7.9 7.91v2H78M85.92 113.58a7.92 7.92 0 0 1-15.84 0z"
          />
        </g>
      </g>
    </svg>
  );
};
export const EmailIcon = props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 156">
    <g data-name="Layer 2">
      <circle cx="78" cy="78" r="78" fill="#f0f0f0" />
      <path
        className="cls-2"
        fill="#fff"
        stroke="#808284"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        d="M56.49 56.37h69.77v45.26H56.49z"
      />
      <path
        className="cls-2"
        fill="#fff"
        stroke="#808284"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        d="M126.26 56.37L91.38 87.44 56.49 56.37h69.77zM56.49 101.63L79.95 79M126.12 101.63L102.67 79"
      />
      <path
        className="cls-3"
        stroke="#808284"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        fill="none"
        d="M47.37 67.69h-15M47.37 90.31H30.84M42.27 79H25.74"
      />
    </g>
  </svg>
);
export const FilesIcon = props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 156">
    <defs />
    <g id="Layer_2" data-name="Layer 2">
      <g id="artwork">
        <circle cx="78" cy="78" r="78" fill="#f0f0f0" />
        <path
          stroke="#808284"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          transform="rotate(-90 72.915 84.135)"
          d="M31.06 52.12h83.71v64.02H31.06z"
        />
        <path
          stroke="#808284"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M97.36 32.39H51.07v83.71h64.03V51.65L97.36 32.39z"
        />
        <path
          fill="none"
          stroke="#808284"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M96.5 32.39v20.34h18.6"
        />
      </g>
    </g>
  </svg>
);
export const SettingsIcon = props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 156">
    <defs />
    <g id="Layer_2" data-name="Layer 2">
      <g id="artwork">
        <circle cx="78" cy="78" r="78" fill="#f0f0f0" />
        <path className="cls-2" d="M38.59 50.89h78.9" />
        <circle className="cls-2" cx="61.38" cy="50.89" r="6.26" />
        <path className="cls-2" d="M38.59 78h78.9" />
        <circle className="cls-2" cx="89.33" cy="78" r="6.26" />
        <path className="cls-2" d="M38.59 105.11h78.9" />
        <circle className="cls-2" cx="70.32" cy="105.11" r="6.26" />
      </g>
    </g>
  </svg>
);
export const FolderIcon = props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 156">
    <g data-name="Layer 2">
      <circle cx="78" cy="78" r="78" fill="#f0f0f0" />
      <path
        d="M47.33 42.62H71.4l13.2 11.3h24.07c6 0 10.9 4.29 10.9 9.6v37.7c0 5.31-4.88 9.6-10.9 9.6H47.33c-6 0-10.9-4.29-10.9-9.6v-49c0-5.3 4.88-9.6 10.9-9.6zM119.57 64.48H36.43"
        fill="#fff"
        stroke="#808284"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
    </g>
  </svg>
);
export const UploadIcon = props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 156">
    <g data-name="Layer 2">
      <circle className="cls-1" cx="78" cy="78" r="78" fill="#f0f0f0" />
      <path
        className="cls-2"
        fill="#fff"
        stroke="#808284"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        d="M34.68 84.98v25.14h86.64V84.98H93.01v8.3H64.45v-8.3H34.68z"
      />
      <path
        className="cls-3"
        stroke="#808284"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        fill="none"
        d="M62.18 59.72l16.54-18.4v36.8M95.25 59.72l-16.53-18.4"
      />
    </g>
  </svg>
);

export const PencilAndPaperIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

export const ListItemsIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8 6L21 6" />
    <path d="M8 12L21 12" />
    <path d="M8 18L21 18" />
    <path d="M3 6L3 6" />
    <path d="M3 12L3 12" />
    <path d="M3 18L3 18" />
  </svg>
);

export const TrashIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    className="feather feather-trash"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3 6L5 6 21 6" />
    <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
  </svg>
);

export const CopiesIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    {...props}
  >
    <rect width="13" height="13" x="9" y="9" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
  </svg>
);

export function FloppyDiskIcon(...props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      {...props}
    >
      <path
        fill="#000"
        d="M10.131 2.66h2.11a.089.089 0 01.088.09v3.253a.089.089 0 01-.089.089h-2.109a.089.089 0 01-.089-.09V2.75a.09.09 0 01.026-.063.09.09 0 01.063-.026z"
      />
      <path
        fill="#000"
        d="M17.133 1H1.962A.962.962 0 001 1.962v16.076a.961.961 0 00.962.962h16.076a.961.961 0 00.962-.962V1h-1.867zM6.31 2.187a.387.387 0 01.387-.387h6.606a.387.387 0 01.387.387v4.378a.386.386 0 01-.387.387H6.697a.387.387 0 01-.387-.387V2.187zm10.343 14.18a.503.503 0 01-.504.502H3.851a.503.503 0 01-.503-.503V9.655a.503.503 0 01.503-.503h12.298a.503.503 0 01.503.503v6.711z"
      />
      <circle cx="17.533" cy="2.333" r="2.067" fill="#fff" />
      <circle cx="17.533" cy="2.333" r="1.867" fill="#E34949" />
    </svg>
  );
}

export function CurvedArrowPointingRightIcon(...props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      fill="none"
      {...props}
    >
      <path fill="url(#pattern0)" d="M0 0h24v24H0z" />
      <defs>
        <pattern
          id="pattern0"
          width="1"
          height="1"
          patternContentUnits="objectBoundingBox"
        >
          <use transform="scale(.01042)" xlinkHref="#image0" />
        </pattern>
        <image
          id="image0"
          width="96"
          height="96"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABGdBTUEAALGOfPtRkwAAA/9JREFUeAHtmb9rFEEYhiNYWFhYpLAQvMLCwiKFhaCgYJHCwkLBwiJlypQWKa7IH2CRMoVFihQWKSwsotgIWggKRiwiWChoIQRRUFDQ95VsuIS77MzOzO4Gnw9edu9uZr7ve2Z2fuxNTWEQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQgcdgJHeprAUcU1I12UTu7ohK6WPx+TKvuumy87eqer9UbalPxbr60vHWCwl6VL0gXpvDQKWR+j7bdqvJCeS4+kx9JPqZR50Djujzsq5Sdbuw54VlqTfkh/Cuub2l+Vrkv2ndNuq7Etqcrhg+7dGb20gaJakhxkFXDbV/u+I/nJS7W7amBc/B5UfqJ7Y567V6Rf0riAu/jOkAxwWmpik+BXuTxo0mjuOh5lQ6mNaaZKPPa6rfgWpZh1pw6+Y/gkdWrz8u4gYoF0Vd5T07UAYiHwqxwCmstfxKN+XaqCOGzXe4p90voQA995t25eeLpcYHN1tnPYv5OJhd96B3hn0adFNrUzvG7NSbYm8Gs7INdBzPtq7+dvOtJM5oPUK+mptCn5tPtV+iyNHqiO6/NpaSCdkaqDXM69vg90+58GfRVkuRhPdOZE70upo831/dgPJU9jMTsSFd9jrntV8ra36+lwT2C5P+SA78d8VTKwUuadzUMpxyCJbaNUTv+O8ykj32vFsuQDWlvmKSol5lj4Ll/MPGqbBOQ6hmAYXdmMHD+TmsYfU69IjgsNg/ehbLZIRPGNevp0Hn5JFwM0tmx8ZDU1vMtostXcUL02p5uaNHZ/Pqe711Is2NDyu45y3Bhgk13FUPU84vpq3spuSaFQY8plzdmjOMa5y/ox77s1PWSFsMiW+5xaCnFYlfE0NZ/Ne7mGSsI3iyzmR9QLaAU35Hoji+eyjZSGn60DliLhD8tyy9J6G/CzdMBA6fq0GjLqXcYnzj4vuAqv8Yu1UAaj5ewvydZUe7TBg+69Q5pO8la+clsjv+KUlJFhejGtGqu79upP6DGZtw3fvJLsimrXQa9+95PSZ1tQcFWsbV6TmHhEhwTrNWKQ5KlsZT/JMetYSM6hZZIy83v1banO2TDJS/nKtwJyqMux6e/J2fkwdZBzv0dJ+fMkOcCABrrqgLcBsQUVWVapcZ3wXt+fDWqh20Kn5L6LKWglZ9p+C+qF9qX0RFqUfEI+LDanQMcNolLfeep2x2MjBNwJG1LM1jq2gwx+XRpIGAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAv8Bgb9CSd2iT1ZF0wAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>
  );
}
export function CurvedArrowPointingLeftIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      fill="none"
      {...props}
    >
      <path
        fill="url(#pattern0)"
        d="M0 0h24v24H0z"
        transform="matrix(-1 0 0 1 24 0)"
      />
      <defs>
        <pattern
          id="pattern0"
          width="1"
          height="1"
          patternContentUnits="objectBoundingBox"
        >
          <use transform="scale(.01042)" xlinkHref="#image0" />
        </pattern>
        <image
          id="image0"
          width="96"
          height="96"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABGdBTUEAALGOfPtRkwAAA/9JREFUeAHtmb9rFEEYhiNYWFhYpLAQvMLCwiKFhaCgYJHCwkLBwiJlypQWKa7IH2CRMoVFihQWKSwsotgIWggKRiwiWChoIQRRUFDQ95VsuIS77MzOzO4Gnw9edu9uZr7ve2Z2fuxNTWEQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQgcdgJHeprAUcU1I12UTu7ohK6WPx+TKvuumy87eqer9UbalPxbr60vHWCwl6VL0gXpvDQKWR+j7bdqvJCeS4+kx9JPqZR50Djujzsq5Sdbuw54VlqTfkh/Cuub2l+Vrkv2ndNuq7Etqcrhg+7dGb20gaJakhxkFXDbV/u+I/nJS7W7amBc/B5UfqJ7Y567V6Rf0riAu/jOkAxwWmpik+BXuTxo0mjuOh5lQ6mNaaZKPPa6rfgWpZh1pw6+Y/gkdWrz8u4gYoF0Vd5T07UAYiHwqxwCmstfxKN+XaqCOGzXe4p90voQA995t25eeLpcYHN1tnPYv5OJhd96B3hn0adFNrUzvG7NSbYm8Gs7INdBzPtq7+dvOtJM5oPUK+mptCn5tPtV+iyNHqiO6/NpaSCdkaqDXM69vg90+58GfRVkuRhPdOZE70upo831/dgPJU9jMTsSFd9jrntV8ra36+lwT2C5P+SA78d8VTKwUuadzUMpxyCJbaNUTv+O8ykj32vFsuQDWlvmKSol5lj4Ll/MPGqbBOQ6hmAYXdmMHD+TmsYfU69IjgsNg/ehbLZIRPGNevp0Hn5JFwM0tmx8ZDU1vMtostXcUL02p5uaNHZ/Pqe711Is2NDyu45y3Bhgk13FUPU84vpq3spuSaFQY8plzdmjOMa5y/ox77s1PWSFsMiW+5xaCnFYlfE0NZ/Ne7mGSsI3iyzmR9QLaAU35Hoji+eyjZSGn60DliLhD8tyy9J6G/CzdMBA6fq0GjLqXcYnzj4vuAqv8Yu1UAaj5ewvydZUe7TBg+69Q5pO8la+clsjv+KUlJFhejGtGqu79upP6DGZtw3fvJLsimrXQa9+95PSZ1tQcFWsbV6TmHhEhwTrNWKQ5KlsZT/JMetYSM6hZZIy83v1banO2TDJS/nKtwJyqMux6e/J2fkwdZBzv0dJ+fMkOcCABrrqgLcBsQUVWVapcZ3wXt+fDWqh20Kn5L6LKWglZ9p+C+qF9qX0RFqUfEI+LDanQMcNolLfeep2x2MjBNwJG1LM1jq2gwx+XRpIGAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAv8Bgb9CSd2iT1ZF0wAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>
  );
}
export function CircularArrowIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="24"
      fill="none"
      {...props}
    >
      <path
        fill="#000"
        d="M19.664 7.968a1.27 1.27 0 00-1.704-.432c-.6.36-.768 1.128-.408 1.728.84 1.368 1.248 3 1.08 4.752-.36 3.696-3.408 6.624-7.104 6.888-4.488.312-8.232-3.288-8.184-7.704.048-4.104 3.408-7.512 7.512-7.584h.048V7.44c0 .528.576.864 1.032.576l4.92-3.072a.674.674 0 000-1.152L11.96.696a.673.673 0 00-1.032.576V3.12C5.096 3.168.44 8.112.872 14.04c.36 4.968 4.368 8.976 9.336 9.336 5.952.456 10.92-4.272 10.92-10.128a9.928 9.928 0 00-1.464-5.28z"
      />
    </svg>
  );
}
export const BoxWithOutboundArrowIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3" />
  </svg>
);
export const PwrLogoIcon = props => (
  <svg {...props} viewBox="0 0 215 213.4">
    <path
      fill="#FFF"
      d="M112.763 65.312h-23.85v36.225h23.85c11.462 0 19.25-6.575 19.25-18.037 0-11.463-7.788-18.188-19.25-18.188zm.912 51.2H88.913V159.3h-16.5V58.712c0-4.262 4.037-8.225 8.462-8.225h32.8c21.25 0 34.85 14.063 34.85 33.013 0 18.95-13.6 33.012-34.85 33.012"
    />
    <path
      fill="#FFF"
      d="M150.75 159.312l-25.037-36.025s-2.788 1.338-11.238 1.338h-8.137l23.862 34.7 20.538-.025M267.125 73.812c5.25 0 8.725-2.525 8.725-7.562 0-5.725-3.812-7.563-8.862-7.563h-9.475v15.125h9.612zM253.938 51.05h14.275c9.4 0 16.487 5.312 16.487 15.262 0 7.425-4.975 15.125-16.012 15.125h-11.175v18.2h-9.063V56.15c0-3 2.313-5.113 5.488-5.113M320.013 83.012V67.475c0-5.863-5.05-9.2-10.775-9.2-4.638 0-10.425 2.45-10.425 9.4v15.537c0 5.863 5.05 9.2 10.762 9.2 4.638 0 10.438-2.45 10.438-9.4zm-30.2.675V68.15c0-11.513 9.812-17.925 19.425-17.925C319.8 50.225 329 57.112 329 67.95v14.587c0 11.525-9.812 17.925-19.425 17.925-10.562 0-19.762-5.925-19.762-16.762M332.7 51.05h9.275l7.625 34.012h.138l8.937-34.012h7.7l8.863 34.212h.137l7.775-34.212h9.138l-12.613 48.8H371.3l-8.725-34.288h-.137l-8.725 34.288h-8.45l-12.538-48.8M403.85 51.05h28.9v7.975h-24.675v11.862h21.888V74.4c0 2.287-1.775 4.462-4.063 4.462h-17.812v12.813h24.95v7.975h-34.013V55.7c0-2.363 2.213-4.65 4.838-4.65M459.413 73.812c5.25 0 8.725-2.525 8.725-7.562 0-5.725-3.825-7.563-8.863-7.563h-8.925v15.125h9.063zM445.338 51.05H460.5c9.138 0 16.5 5.312 16.5 15.262 0 5.788-3.062 11.788-9.612 14.113L479.45 99.65h-9.875l-11.387-18.2h-7.838v18.2h-9.062V55.287c0-2.525 1.437-4.237 4.062-4.237M266.575 131.637c5.25 0 8.725-2.525 8.725-7.562 0-5.725-3.812-7.563-8.862-7.563h-8.925v15.125h9.062zm-13.962-22.762h15.062c9.138 0 16.5 5.312 16.5 15.262 0 5.788-3.062 11.788-9.612 14.113l12.062 19.225h-9.875l-11.387-18.2h-7.838v18.2h-9.062v-44.513c0-2.362 1.55-4.087 4.162-4.087M296.95 108.875h29.263v7.975h-24.675v11.862h21.875v3.85c0 2.288-1.563 4.125-3.85 4.125h-18.025V149.5h24.95v7.975h-34.013V113.05c0-2.288 2.1-4.163 4.475-4.163M333.925 108.875h9.813l10.975 35.787h.137l10.975-35.787h9l-16.087 48.8h-8.863l-15.95-48.8M388.088 108.875h4.45v48.6h-9.063v-44.188c0-2.862 1.913-4.412 4.613-4.412M407.775 108.875h29.35v7.975H412.45v11.862h21.875v3.85c0 2.288-1.312 4.125-3.925 4.125h-17.95V149.5h24.938v7.975h-34.013v-44.263c0-2.862 1.613-4.325 4.388-4.325M442.913 108.875h9.275l7.625 34.012h.137l8.925-34.012h7.7l8.863 34.212h.137l7.775-34.212h9.125l-12.612 48.8h-8.375l-8.725-34.288h-.138l-8.725 34.288h-8.45l-12.537-48.8M502.138 146.225l8.175-3.2c1.837 4.7 6.275 7.362 11.725 7.362 4.9 0 9.537-1.912 9.537-6.4 0-3.612-2.937-5.25-6.675-6.337l-8.175-1.975c-6.475-1.638-11.65-4.563-11.65-13.15 0-9.138 7.975-14.45 17.375-14.45 8.113 0 13.975 2.662 17.1 9.95l-7.425 3.275c-2.112-4.088-5.725-5.588-10.425-5.588-3.95 0-7.775 1.775-7.775 6.138 0 3.412 3.263 4.975 7.088 6l8.312 2.037c5.8 1.363 11.113 4.838 11.113 13.5 0 8.925-7.975 14.85-18.675 14.85-8.925 0-17.113-3.75-19.638-11.987"
    />
    <path
      fill="#d4e2e1"
      d="M15.913 107.087c-.063-22.725 7.212-42.325 22.075-59.512L25.95 37.162C8.488 57.375-.063 80.412 0 107.125c.15 58.837 47.975 106.413 106.8 106.262l-.037-15.9c-50.05.125-90.725-40.35-90.85-90.4"
    />
    <path
      fill="#5b9b97"
      d="M196.325 119.237c-6.212 45.075-44.05 78.138-89.55 78.25h-.012l.037 15.9c53.475-.137 97.95-38.987 105.263-91.975l-15.738-2.175"
    />
    <path
      fill="#6c6cc5"
      d="M162.75 16.362l-8.387 13.5s.012 0 .012.013c30.913 19.2 46.925 53.312 41.95 89.362l15.738 2.175c5.85-42.375-12.975-82.475-49.313-105.05"
    />
    <path
      fill="#afafe3"
      d="M154.363 29.875l8.387-13.5C135.513-.55 105.763-4.388 75.125 5.062l4.688 15.2h.012c26.063-8.037 51.375-4.775 74.538 9.613"
    />
    <path
      fill="#7edb85"
      d="M79.813 20.262L75.125 5.05c-20.4 6.3-35.2 15.962-49.175 32.125l12.038 10.412C49.875 33.85 62.45 25.625 79.813 20.275"
    />
  </svg>
);
